export { HandShakingIcon } from './HandShakingIcon'
